<template>
  <main class="app-ecommerce-confirm">
    <HeaderCheckout />
    <section class="page">
      <NuxtPage />
    </section>
    <Footer />
  </main>
</template>

<style lang="scss">
  @mixin site-container {
    @apply w-full md:site:max-w-[1440px];
    @apply md:site:mx-auto;
  }

  .app-ecommerce-confirm {
    @apply flex flex-col min-h-screen;

    > .page {
      @apply flex-1;
      @apply bg-neutral-high-light;
    }
  }
</style>
